import script from "./CommonOpenButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./CommonOpenButton.vue?vue&type=script&lang=ts&setup=true"

import "./CommonOpenButton.vue?vue&type=style&index=0&id=67320475&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-67320475"]])

export default __exports__